import * as React from 'react';
import { Box } from '../../ui/box/box';
import { Title } from '../../ui/title/title';
import { About } from '../about/about';
import { Banner } from '../banner/banner';
import { Cities } from '../cities/cities';
import { Filters } from '../filters/filters';
import { Footer } from '../footer/footer';
import { GKs } from '../gks/gks';
import { Mortgage } from '../mortgage/mortgage';
import { OnlinePurchase } from '../OnlinePurchase';
import { Offices } from '../offices/offices';
import { Fragment } from '../scrollspy/scrollspy';
import { Sidebar } from '../sidebar/sidebar';
import { PikStandard } from '../pik-standard';
import { connect } from 'react-redux';
import { initPikData } from '../../actions/pikData';

const styles = require('./app.css');

interface IAppProps {
  initPikData(): void;
}

const FRAGMENT_OFFSET = -80;

export class AppComponent extends React.PureComponent<IAppProps> {
  public componentDidMount() {
    this.props.initPikData();
  }

  public render() {
    return (
      <div className={styles['page']}>
        <Sidebar />
        <main className={styles['main']}>
          <section>
            <Banner />
          </section>
          <Fragment name="catalog" offset={FRAGMENT_OFFSET}>
            <section className={styles['section']}>
              <Box boxStyles={styles['title-box']}>
                <Title>Все новостройки ПИК</Title>
              </Box>
              <Filters />
            </section>
            <section className={styles['section']}>
              <Cities />
            </section>
            <section>
              <GKs />
            </section>
          </Fragment>
          <Fragment name="mortgage" offset={FRAGMENT_OFFSET}>
            <section className={styles['section']}>
              <Box boxStyles={styles['title-box']}>
                <Title>Ипотека</Title>
              </Box>
              <Mortgage />
            </section>
          </Fragment>
          <Fragment name="online-purchase" offset={FRAGMENT_OFFSET}>
            <section className={styles['section']}>
              <Box boxStyles={styles['title-box']}>
                <Title>
                  Покупка <u className={styles['emphasized']}>онлайн</u> — просто!
                </Title>
              </Box>
              <OnlinePurchase />
            </section>
          </Fragment>
          <Fragment name="pikstandart" offset={FRAGMENT_OFFSET}>
            <section>
              <PikStandard />
            </section>
          </Fragment>
          <Fragment name="offices" offset={FRAGMENT_OFFSET}>
            <section>
              <Box top={30} boxStyles={styles['title-box']}>
                <Title>Жилые комплексы</Title>
              </Box>
              <Offices />
            </section>
          </Fragment>
          <Fragment name="about" offset={FRAGMENT_OFFSET}>
            <section className={styles['section']}>
              <Box boxStyles={styles['title-box']}>
                <Title>О компании</Title>
              </Box>
              <About />
            </section>
          </Fragment>
          <Footer />
        </main>
      </div>
    );
  }
}

export const App = connect(null, { initPikData })(AppComponent);
